module.exports = __webpack_public_path__ + "img/nc.7cac5aeb.svg";